import type { EndpointBuilder } from '@reduxjs/toolkit/query';

import type { DynamicBaseQueryFn } from '../../../utils/create-dynamic-base-query';

export type TagTypes =
  | 'Dbms'
  | 'DbmsPlugins'
  | 'Database'
  | 'RemoteConnection'
  | 'UserSettings'
  | 'Credentials'
  | 'ProgressEvents';

export const tagTypes: TagTypes[] = [
  'Dbms',
  'DbmsPlugins',
  'Database',
  'RemoteConnection',
  'UserSettings',
  'Credentials',
  'ProgressEvents',
] as const;

export type Builder = EndpointBuilder<DynamicBaseQueryFn, TagTypes, 'relateApi'>;
